import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { outlinedFieldProps, disabledOutlinedSx } from '../utils/fieldStyles';

const getDurationDisplay = (start, end) => {
    if (!start || !end) return '';

    const [startHour, startMinute = 0] = String(start).split(':').map(Number);
    const [endHour, endMinute = 0] = String(end).split(':').map(Number);

    if (Number.isNaN(startHour) || Number.isNaN(endHour)) return '';

    const startTotalMinutes = startHour * 60 + startMinute;
    let endTotalMinutes = endHour * 60 + endMinute;

    if (endTotalMinutes < startTotalMinutes) {
        endTotalMinutes += 24 * 60;
    }

    const diffMinutes = endTotalMinutes - startTotalMinutes;
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    if (hours > 0 && minutes > 0) {
        return `${hours}h ${minutes}m`;
    }
    if (hours > 0) {
        return `${hours}h`;
    }
    return `${minutes}m`;
};

const DurationCalcField = ({ field, data }) => (
    <Grid container spacing={2}>
        <Grid item xs={12}>
            <TextField
                {...outlinedFieldProps}
                label={<FieldLabel label={field.label} tooltip={field.tooltip} />}
                value={getDurationDisplay(data.start_time, data.end_time)}
                disabled
                sx={disabledOutlinedSx}
            />
        </Grid>
    </Grid>
);

export default DurationCalcField;
